/* @flow */

import React, { Component } from 'react';
import { Provider } from 'react-redux';
import App from '../screens/App';

export default class Root extends Component {
  render() {
    const { store } = this.props;
    return (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/bucket/containers/Root.js